import type { ITeamMember } from '~/types/teamMember/models'
import { useLoggedInUserStore } from '~/stores/loggedInUser'

export default defineNuxtPlugin(() => {
  function getLoggedInTeamMember(): ITeamMember | undefined {
    return useLoggedInUserStore().getLoggedInTeamMember
  }
  return { provide: { getLoggedInTeamMember } }
})
